import Qs from 'qs'
import request from '@/util/request'
import {
  JSON_CONFIG,
  FORM_CONFIG,
  getAPILangParam
} from '@/util/helper.js'

export function levelUp (patientId) {
  return request({
    url: `/patient/${patientId}/levelUp`,
    method: 'get',
    header: JSON_CONFIG
  })
}

export function assignSchedule (patientId, requestBody) {
  return request({
    url: `/patient/${patientId}/schedule`,
    method: 'post',
    header: JSON_CONFIG,
    data: requestBody
  })
}

export function updateTemplate (patientId, requestBody) {
  return request({
    url: `/patient/${patientId}/schedule/info`,
    method: 'post',
    header: JSON_CONFIG,
    data: requestBody
  })
}

export function removePatientSchedule (patientId) {
  return request({
    url: `/patient/${patientId}/schedule`,
    method: 'delete',
    header: JSON_CONFIG
  })
}

export function updateCheckList (patientId, requestBody) {
  return request({
    url: `/record/${patientId}/check`,
    method: 'post',
    header: JSON_CONFIG,
    data: requestBody
  })
}

// NOTE: 等待廢棄
export function getSchedule (patientId) {
  return request({
    url: `/patient/${patientId}/schedule`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam()
    }
  })
}

export function getScheduleV2 (patientId, withoutLevel = 0) {
  return request({
    url: `/patient/${patientId}/schedule/list`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam(),
      withoutLevel: withoutLevel
    }
  })
}

export function getScheduleLevelDetail (patientId, scheduleId, level) {
  return request({
    url: `/patient/${patientId}/schedule/${scheduleId}/level/${level}`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam()
    }
  })
}

export function updateLevelOfSchedule (patientId, level, requestBody) {
  return request({
    url: `/patient/${patientId}/levelInfo/${level}`,
    method: 'post',
    header: JSON_CONFIG,
    data: requestBody
  })
}

export function completePatientSchedule (patientId, scheduleEndMsg) {
  return request({
    url: `/patient/${patientId}/schedule/complete`,
    method: 'post',
    header: FORM_CONFIG,
    data: Qs.stringify({
      scheduleEndMsg: scheduleEndMsg
    })
  })
}

export function duplicatePatientScheduleById (patientId, scheduleId, title) {
  return request({
    url: `/patient/${patientId}/schedule/copy`,
    method: 'post',
    header: FORM_CONFIG,
    data: Qs.stringify({
      id: scheduleId,
      title: title
    })
  })
}

export function getCurrentLevelInfo (patientId) {
  return request({
    url: `/patient/${patientId}/levelInfo`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam()
    }
  })
}

export function getHistoryLevelInfo (patientId, level) {
  return request({
    url: `/patient/${patientId}/levelInfo/${level}`,
    method: 'get',
    header: JSON_CONFIG,
    params: {
      lang: getAPILangParam()
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/patient/schedule.js